export default "__VITE_ASSET__nQ5hdTiJ__"